import {getLocale} from 'jscommon/localeUtil.js';
import {SyncPost,SyncGet} from 'jscommon/ajaxUtil.js'

  //获取URL地址栏参数 sysid
  export const getQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      var value = unescape(r[2]);
      if (name == 'sysid') {
        return getRealSysId(value);
      }
      value = checkLoginParameter(value);
      return value;
    }
    return null;
  }

  //获取URL地址栏参数 hashrouter
  export const getHashQueryString = (variable) => {
    const after = window.location.hash.split('?', 2)[1]
    if (after) {
    const reg = new RegExp('(^|&)' + variable + '=([^&]*)(&|$)')
    const r = after.match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    } else {
      return false
    }
    }
  }

  

export const getQueryStringFromStr = (name, curstr) => {
  if (!curstr) return;
  var string = (curstr !== undefined) ? curstr : window.location.search;
  var result = string.match(new RegExp("[^\?\&]+=[^\?\&]+", "g"));
  if (result == null) {
    result = '';
  } else {
    var params = {};
    for (var i = 0; i < result.length; i++) {
      var res = result[i].split('=');
      var key = res[0],
        value = res[1];
      params[key] = value;
    }
    result = params;
  }
  if (!result) {
    return null;
  } else {
    if (name == 'sysid') {
      return getRealSysId(result[name]);
    }
    value = checkLoginParameter(result[name]);
    return value;
  }
}
export const getUrlString = (url, name) => {
  if (!url) return null;
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var index = url.indexOf('?');
  if (index === -1) {
    return null;
  }
  var r = url.substring(index + 1).match(reg);
  if (r != null) {
    var value = unescape(r[2]);
    if (name == 'sysid') {
      return getRealSysId(value);
    }
    value = checkLoginParameter(value);
    return value;
  }
  return null;
}
export const getRealSysId = (sysid) => {
  if (!sysid) return "yht";
  var reg = "^[a-zA-Z]{2,50}$";
  var sysidtmp = sysid.match(reg);
  if (sysidtmp == null)
    sysid = "yht";
  return sysid;
}
export const checkLoginParameter = (para) => {
  if (para == null)
    return para;
  var reg = new RegExp("[<>]");
  if (para.match(reg) != null) {
    alert('不能包含特殊字符');
    return null;
  }
  return para;
}
export const getCasUrl = (sysid) => {
  var casurl = window.LocationUrl;
  if (!window.CasBaseUrl) {
    SyncGet('/user/getcasurl.do', function (result) {
      if ((result.status == 1) && result.casurl) {
        casurl = result.casurl;
      }
    }, function (xhr, status, err) {});
    if (/\/$/.test(casurl)) {
      casurl = casurl.substring(0, (casurl.length - 1));
    }
    window.CasBaseUrl = casurl;
  }
  return window.CasBaseUrl + "/login";
}
export const getFileObjectURL = (file) => {
  var url = null;
  if (window.createObjectURL != undefined) {
    url = window.createObjectURL(file)
  } else if (window.URL != undefined) {
    url = window.URL.createObjectURL(file)
  } else if (window.webkitURL != undefined) {
    url = window.webkitURL.createObjectURL(file)
  }
  return url
}
export const toDefaultLogin = (_token) => {
  var _loginUrl = getCasUrl();
  var originUrl = window.location.origin;
  if (!originUrl) {
    originUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }
  let uuas = window.location.pathname.indexOf("iuap-uuas-user") == -1 ? '' : '/iuap-uuas-user'
  var serviceUrl = getHashQueryString("service") || (originUrl + uuas + "/usercenter");
  var sysid = getHashQueryString("sysid") || 'yht';
  var locale = getLocale();
  let workUrl = getHashQueryString("workUrl") || getHashQueryString("serviceUrl") || (originUrl + uuas + "/usercenter");
  // console.log(_token,getHashQueryString("serviceUrl"),workUrl,12345)
  // 判断是注册还是激活来的
  let isactivate = window.location.hash.indexOf("/activate") == -1 ? true : false
  if (!/\/$/.test(_loginUrl)) {
    _loginUrl = _loginUrl;
  }

  var hrefStr;
  if (_token) {
    hrefStr = _loginUrl + '?sysid=' + sysid + '&token=' + _token + '&service=' + encodeURIComponent(serviceUrl);
    if (serviceUrl.indexOf(_loginUrl) !== -1) {
      hrefStr = serviceUrl + '&token=' + _token + "&sysid=" + sysid;
    }
  } else {
    //不改变原有的逻辑 判断在激活的时候一定跳转workUrl
    if (isactivate) {
      hrefStr = _loginUrl + '?sysid=' + sysid + '&service=' + encodeURIComponent(serviceUrl);
      if (serviceUrl.indexOf(_loginUrl) !== -1) {
        hrefStr = serviceUrl + "&sysid=" + sysid;
      }
    } else {
      hrefStr = workUrl
    }
  }

  if (hrefStr.indexOf('locale=') !== -1) {
    hrefStr.replace('locale=', '');
  }
  if (isactivate) {
    hrefStr = hrefStr + "&locale=" + locale;
  }
  // else{
  //   let worklocale
  //   switch (locale) {
  //     case 'zh':
  //       worklocale='zh_CN'
  //       break;
  //     case 'tw':
  //       worklocale='zh_TW'
  //       break;
  //     case 'en':
  //       worklocale='en_US'
  //       break;
  //     default:
  //       worklocale='zh_CN'
  //       break;
  //   }
  //   hrefStr = hrefStr + "?locale=" + worklocale;     
  // }
  window.location.href = hrefStr;


}
export const toDefaultRegister = (_token) => {
  var originUrl = window.location.origin;
  if (!originUrl) {
    originUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }
  var _loginUrl = originUrl + "/register";
  var serviceUrl = getHashQueryString("service") || (originUrl + "/usercenter");
  var sysid = getHashQueryString("sysid") || 'yht';
  var locale = getLocale();

  if (!/\/$/.test(_loginUrl)) {
    _loginUrl = _loginUrl;
  }

  var hrefStr;

  hrefStr = _loginUrl + '?sysid=' + sysid + '&service=' + encodeURIComponent(serviceUrl);
  if (serviceUrl.indexOf(_loginUrl) !== -1) {
    hrefStr = serviceUrl + "&sysid=" + sysid;
  }

  if (hrefStr.indexOf('locale=') !== -1) {
    hrefStr.replace('locale=', '');
  }
  hrefStr = hrefStr + "&locale=" + locale;
  window.location.href = hrefStr;
}